import React from 'react';

export const renderRawHTML = rawHTML => <div dangerouslySetInnerHTML={{ __html: decodeURIComponent(rawHTML) }} />;

